import { Trash, Transfer, Network } from '@drift-labs/icons';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import IconButton from 'src/components/primitives/IconButton/IconButton';
import Button from 'src/components/primitives/Button/Button';
import {
	AccountsTableItem,
	UseAccountsTable,
} from 'src/components/PortfolioPage/PortfolioAccountsSubPage/AccountsTable/hooks/useAccountsTable';

interface Props
	extends
		Pick<
			AccountsTableItem,
			| 'hasClaimableRent'
			| 'userId'
			| 'authority'
			| 'delegate'
			| 'isIsolatedAccount'
			| 'isDelegatedToNonEmbeddedWallet'
		>,
		Pick<
			UseAccountsTable,
			| 'handleReclaimRent'
			| 'claimingRentAccountId'
			| 'openDepositModal'
			| 'openWithdrawModal'
			| 'openTransferModal'
			| 'openUpdateDelegateModal'
			| 'openDeleteAccountModal'
		> {}

export default function AccountsTableActionCell({
	hasClaimableRent,
	userId,
	authority,
	delegate,
	isIsolatedAccount,
	isDelegatedToNonEmbeddedWallet,
	handleReclaimRent,
	claimingRentAccountId,
	openDepositModal,
	openWithdrawModal,
	openTransferModal,
	openUpdateDelegateModal,
	openDeleteAccountModal,
}: Props) {
	return (
		<>
			{hasClaimableRent && (
				<Button
					size="sm"
					variant="secondary"
					onClick={() => handleReclaimRent(userId)}
					isLoading={claimingRentAccountId === userId}
				>
					Claim
				</Button>
			)}

			<Button
				size="sm"
				variant="secondary"
				onClick={() => openDepositModal(userId, authority)}
			>
				Deposit
			</Button>

			<Button
				size="sm"
				variant="secondary"
				onClick={() => openWithdrawModal(userId, authority)}
			>
				Withdraw
			</Button>

			{!isIsolatedAccount && (
				<Tooltip decoration="none" content="Transfer Assets">
					<IconButton
						size="sm"
						variant="secondary"
						onClick={() => openTransferModal(userId, authority)}
						icon={Transfer}
					/>
				</Tooltip>
			)}

			{!isDelegatedToNonEmbeddedWallet && (
				<Tooltip decoration="none" content="Set Up Delegate">
					<IconButton
						size="sm"
						variant="secondary"
						onClick={() => openUpdateDelegateModal(userId, authority, delegate)}
						icon={Network}
					/>
				</Tooltip>
			)}

			<Tooltip decoration="none" content="Delete Account">
				<IconButton
					size="sm"
					variant="secondary"
					onClick={() => openDeleteAccountModal(userId)}
					icon={Trash}
				/>
			</Tooltip>
		</>
	);
}
